import {useCallback} from 'react';
import {usePlayerContext} from './usePlayerContext';

export const useSeek = (): ((timestamp: number) => void) => {
  const {player} = usePlayerContext();

  const onSeek = useCallback(
    (timestamp: number) => {
      if (!player) return;

      player.seek(timestamp, 'ui');
    },
    [player]
  );

  return onSeek;
};
